import React, { createContext, useContext } from "react"
import { IDateTimeFormatterBuilder } from "./types/IDateTimeFormatter"
import { StubFormatterBuilder } from "./implementation/StubFormatter"
import { useTranslations } from "../i18n/provider"
import { useUserSettings } from "@cirrus/common/UserSettings"

interface IContext {
  formatterBuilder: IDateTimeFormatterBuilder;
}

const TheContext = createContext<IContext>({ formatterBuilder: new StubFormatterBuilder() })

interface IProps {
  formatterBuilder?: IDateTimeFormatterBuilder;
  children: any;
}

export function DateTimeProvider(props: IProps) {
  const { children, formatterBuilder } = props
  return <TheContext.Provider value={{ formatterBuilder: formatterBuilder ?? new StubFormatterBuilder() }}>{children}</TheContext.Provider>
}

export function useDateTimeProvider() {
  const { i18n } = useTranslations()
  const { state } = useUserSettings()
  
  const context = useContext(TheContext)
  if (context === undefined) {
    throw new Error("[useDateTimeProvider]")
  }
  
  return {
    formatter: context.formatterBuilder.build(i18n, state)
  }
}
